// A supplier's page of a nota fiscal (04/11/2026): what the supplier reads. White label: never "Aubaine" nor "plataforma"; the institution's name
// comes from its branding and the company's data from its own register.
export default {
  title: 'Envio de nota fiscal',
  loading: 'Carregando',
  lead: '{company} pede a nota fiscal de {supplier} referente a {month}. Abaixo estão os dados para a emissão; depois, envie o PDF e o XML da nota.',
  copy: 'Copiar',
  copied: 'Copiado',
  leave: 'Encerrar e esquecer este link neste navegador',
  what: {
    title: 'O que emitir',
    contract: 'Contrato',
    number: 'nº {n}',
    competence: 'Competência',
    due: 'Vencimento do pagamento',
    amount: 'Valor combinado',
    payment: 'Forma de pagamento',
  },
  to: {
    title: 'Emitir a nota para',
    text: 'Use exatamente estes dados como tomador da nota.',
    legalName: 'Razão social',
    document: 'CNPJ',
    address: 'Endereço',
    email: 'E-mail para envio',
    phone: 'Telefone',
    instructions: 'Instruções',
  },
  send: {
    title: 'Enviar a nota',
    text: 'Envie o PDF e o XML da nota fiscal emitida. Se já enviou e precisa corrigir, envie de novo: o novo arquivo substitui o anterior.',
    pdf: 'PDF da nota',
    xml: 'XML da nota',
    note: 'Observação (opcional)',
    button: 'Enviar nota',
    again: 'Enviar de novo',
    done: 'Recebemos a sua nota. Obrigado! O financeiro vai conferir.',
    failed: 'Não foi possível enviar agora. Tente de novo em alguns minutos.',
    fine: 'Este endereço é só seu: não o compartilhe. Ele funciona até {date}.',
  },
  received: {
    title: 'Já recebemos arquivos seus em {date}',
    number: 'nota {n}',
    again: 'Se precisar corrigir, envie de novo.',
  },
  warnings: {
    recipient_mismatch: 'O CNPJ do tomador no XML não é o que pedimos para a emissão. Confira antes de seguir; o financeiro também vai verificar.',
    issuer_mismatch: 'O CNPJ do emitente no XML é diferente do cadastrado para a sua empresa. O financeiro vai verificar.',
    amount_differs: 'O valor do XML é diferente do valor combinado. O financeiro vai verificar.',
    xml_unrecognized: 'Não conseguimos ler os dados deste XML. Ele foi guardado e o financeiro vai conferir.',
  },
  closed: {
    title: 'Nota recebida e conferida',
    text: 'O financeiro já conferiu esta nota. Não é preciso enviar mais nada. Obrigado!',
  },
  problem: {
    invalid: {
      title: 'Link inválido',
      text: 'Este endereço não abre nenhuma nota. Use o link completo que recebemos por e-mail ou WhatsApp, ou peça um novo ao financeiro.',
    },
    expired: {
      title: 'Link expirado',
      text: 'Este link venceu ou foi substituído por um mais novo. Peça um novo link ao financeiro ou use o mais recente que enviamos.',
    },
    error: {
      title: 'Não foi possível abrir a página',
      text: 'Tente de novo em alguns minutos.',
    },
    retry: 'Tentar de novo',
  },
}
